export const getStateName = fragmentName => `__PRELOADED_STATE_${fragmentName}__`
